import React from "react";
import { Box, GlobalStyles } from "@mui/material";
import BaseWrapper from "./BaseWrapper";
import MainContentWrapper from "./MainContentWrapper";
import Header from "../Header/Header";
import { FONT_INTER } from "../../../styles/fonts";

// Shared page chrome for Globo Marca routes (header + wrappers), reused by CultureHub and /maintenance
const GloboRouteWrapper = ({ children, maxWidth, headerProps, sx }) => (
  <Box sx={{ fontFamily: FONT_INTER, ...sx }}>
    {/* !important beats base.scss's duplicated rule; both html and body need it, since base.scss
    sets a background on html too, and the browser uses html's color (not body's) to paint the
    canvas for the full scrollable page whenever content is taller than one viewport */}
    <GlobalStyles
      styles={{
        html: { backgroundColor: "#fff !important" },
        body: { backgroundColor: "#fff !important" },
      }}
    />
    <BaseWrapper>
      {/* BaseWrapper: main canvas area, where components like Header should be placed */}
      <Header {...headerProps} />

      <MainContentWrapper maxWidth={maxWidth}>
        {/* MainContentWrapper: area where the other main informations should be placed */}
        {children}
      </MainContentWrapper>
    </BaseWrapper>
  </Box>
);

export default GloboRouteWrapper;
